import Vue from "vue";
export default {
  data() {
    return {
      collapsed: true,
      filters: {}
    };
  },

  computed: {
    paginationApiParameter() {
      return (
        this.$route.meta.pagination && this.$route.meta.pagination.apiParameter
      );
    },

    paginationCollectionName() {
      return (
        this.$route.meta.pagination && this.$route.meta.pagination.collection
      );
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => vm.fetchData(1, vm.activeFilters()));
  },

  methods: {
    fetchData(page, filters = {}) {
      filters.page = page;
      // this.$refs.paginator.setStateLoading(true);
      this.$collection[this.paginationCollectionName]
        .all(filters)
        .then(response => {
          this.setData(page, response);
          // this.$refs.paginator.setStateLoading(false);
        });
    },

    clearFilters() {
      var collapsed = this.collapsed;
      if (typeof this.$options.data !== "undefined") {
        Object.assign(this.$data, this.$options.data.apply(this), {
          collapsed: collapsed
        });
      }
      this.filter();
    },

    activeFilters() {
      var _filters = {},
        value = null;
      for (var key in this.filters) {
        value = this.filters[key];
        if ((typeof value == "string" && value.length == 0) || value == null)
          continue;
        _filters[key] = value;
      }
      _filters.pagination = 1;
      _filters.limit = 15;
      return _filters;
    },

    filter() {
      this.fetchData(1, this.activeFilters());
    },

    onPageChange(page) {
      this.fetchData(page, this.activeFilters());
    },

    setData(page, response) {
      if (!this.$refs.paginator) return;
      this.$refs.paginator.update({
        page: page,
        totalItems: response.totalItems,
        totalPages: response.totalPages,
        items: response[this.paginationApiParameter]
      });
    }
  }
};
